import { render, staticRenderFns } from "./ActivableProductList.vue?vue&type=template&id=4dd96662&scoped=true&"
import script from "./ActivableProductList.vue?vue&type=script&lang=js&"
export * from "./ActivableProductList.vue?vue&type=script&lang=js&"
import style0 from "./ActivableProductList.vue?vue&type=style&index=0&id=4dd96662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd96662",
  null
  
)

export default component.exports